import script from "./CreditMetricsChart.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditMetricsChart.vue?vue&type=script&setup=true&lang=js"

import "./CreditMetricsChart.vue?vue&type=style&index=0&id=1c0edb44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c0edb44"]])

export default __exports__